// 导入所需组件
import Vue from "vue"
import Router from "vue-router"
Vue.use(Router);

// 配置路由懒加载
const router =  new Router ({
    // mode: 'history',
    routes:[
        {
            path: '/',
            // name: 'index',
            component: resolve => require(['@/components/index/home'], resolve),
            children: [
                // 首页
                {
                    path: '/',
                    name: 'index',
                    component: resolve => require(['@/components/index/index'], resolve)
                },
                // 产品服务
                {
                    path: '/service',
                    name: 'service',
                    component: resolve => require(['@/components/service/index'], resolve)
                },
                // 智能设备
                {
                    path: '/device',
                    name: 'device',
                    component: resolve => require(['@/components/device/index'], resolve)
                },
                // 产品价格
                {
                    path: '/price',
                    name: 'price',
                    component: resolve => require(['@/components/price/index'], resolve)
                },
                // 帮助与支持
                {
                    path: '/help',
                    name: 'help',
                    // redirect: '/help/list',
                    component: resolve => require(['@/components/help/index'], resolve),
                    children: [
                        /*{
                            path: '/help/list',
                            component: resolve => require(['@/components/help/list'], resolve),
                        },*/
                        /*{
                            path: '/help/helpArticle',
                            component: resolve => require(['@/components/help/helpArticle'], resolve),
                        }*/
                    ]
                },
                // 帮助与支持文章内容
                {
                    path: '/help/helpArticle',
                    name: 'helpArticle',
                    component: resolve => require(['@/components/help/helpArticle'], resolve)
                },

                // 关于我们
                {
                    path: '/about',
                    name: 'about',
                    component: resolve => require(['@/components/about/index'], resolve)
                },
                // 代理加盟
                {
                    path: '/join',
                    name: 'join',
                    component: resolve => require(['@/components/join/index'], resolve)
                },
                // 我的购物车
                {
                    path: '/shoppingCart',
                    name: 'shoppingCart',
                    component: resolve => require(['@/components/shoppingCart/index'], resolve)
                },
            ]
        },
        // 登录、注册
        {
            path: '/login',
            name: 'login',
            component: resolve => require(['@/components/login/login'], resolve)
        },
        {
            path: '/register',
            name: 'register',
            component: resolve => require(['@/components/login/register'], resolve)
        },
        {
            path: '/getPassword',
            name: 'getPassword',
            component: resolve => require(['@/components/login/getPassword'], resolve)
        },

        // 申请加入
        {
            path: '/joinUs',
            name: 'joinUs',
            component: resolve => require(['@/components/join/joinUs'], resolve)
        },
        // 个人中心
        {
            path: '/userCenter',
            name: 'userCenter',
            redirect: '/userCenter/server',
            component: resolve => require(['@/components/userCenter/index'], resolve),
            children: [
                {
                    path: '/userCenter/server',
                    component: resolve => require(['@/components/userCenter/server'], resolve),
                },
                {
                    path: '/userCenter/order',
                    component: resolve => require(['@/components/userCenter/order'], resolve),
                },
                {
                    path: '/userCenter/userinfo',
                    component: resolve => require(['@/components/userCenter/userinfo'], resolve),
                },
            ]
        },

    ],
})
// 导出
export default router;

router.beforeEach((to,from,next) => {
    window.scrollTo(0,0);
    if (to.path) {
        _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    };

    var system ={};
    var u = navigator.userAgent;
    system.iPhone = u.indexOf('iPhone');
    system.Android = u.indexOf('Android');
    var jumpUrl = to.fullPath;
    if (system.iPhone > -1 || system.Android > -1){ //如果是手机用户则跳转
        // alert('手机')
        // window.location.href="https://www.ihuizong.cn/mobile/#" + jumpUrl
    }else{
        // alert('电脑')
        // window.location.href="/mobile"
    }
    next();
});




// WEBPACK FOOTER //
// ./src/routers/index.js